import { clsx } from 'clsx';
import { FeedTab } from '../model/feedFilter.types';

const TABS: { value: FeedTab; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'mine', label: 'My Posts' },
  { value: 'drafts', label: 'Drafts' },
  { value: 'scheduled', label: 'Scheduled' },
];

type Props = {
  value: FeedTab;
  onChange: (value: FeedTab) => void;
};

export const FeedTabs = ({ value, onChange }: Props) => (
  <div
    role="tablist"
    aria-label="Community posts"
    className="flex items-center gap-4"
  >
    {TABS.map((tab) => {
      const active = tab.value === value;
      return (
        <button
          key={tab.value}
          type="button"
          role="tab"
          onClick={() => onChange(tab.value)}
          aria-selected={active}
          className={clsx(
            'rounded-[10px] px-4 py-2 text-center text-base font-medium leading-6',
            active ? 'bg-[#EDE5FC] text-[#350584]' : 'text-[#131313]',
          )}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);
